import React from 'react';
import { Link as ChakraLink } from '@chakra-ui/react';
import withLink from '@components/atoms/withLink';

const Link = (props) => {
  return <ChakraLink {...props} />;
};

export default withLink(Link);
